/**
 * Reusable placeholder for documented features planned for a future release.
 */
import React from 'react';
import { Link } from 'react-router-dom';

interface ComingSoonPageProps {
  title: string;
  icon: string;
  subtitle: string;
  description?: string;
  gradient?: string;
  actionLabel?: string;
  actionHref?: string;
}

const ComingSoonPage: React.FC<ComingSoonPageProps> = ({
  title,
  icon,
  subtitle,
  description = 'This feature is on the roadmap.',
  gradient = 'linear-gradient(135deg, #ff9a56 0%, #ff6b35 100%)',
  actionLabel,
  actionHref,
}) => (
  <div style={{ maxWidth: '700px', margin: '0 auto' }}>
    <div style={{
      background: gradient,
      borderRadius: '16px',
      padding: '24px',
      marginBottom: '24px',
      color: 'white',
    }}>
      <h1 style={{ margin: '0 0 8px 0', fontSize: '26px' }}>{icon} {title}</h1>
      <p style={{ margin: 0, opacity: 0.95, fontSize: '15px' }}>{subtitle}</p>
    </div>
    <div style={{
      background: 'white',
      borderRadius: '16px',
      padding: '40px',
      textAlign: 'center',
      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
      border: '2px dashed #e0e0e0',
    }}>
      <span style={{ fontSize: '48px' }}>{icon}</span>
      <h2 style={{ margin: '20px 0 12px 0', fontSize: '20px', color: '#333' }}>Planned for a future release</h2>
      <p style={{ margin: 0, color: '#666' }}>{description}</p>
      {actionLabel && actionHref && (
        <p style={{ marginTop: '16px' }}>
          <Link to={actionHref} style={{ color: '#667eea', fontSize: '14px', fontWeight: 600 }}>
            {actionLabel}
          </Link>
        </p>
      )}
    </div>
  </div>
);

export default ComingSoonPage;
